import React from 'react';
import '../../../css/ScientificCV.css';

const ScientificCVTemplate = ({ data, filters }) => {
    const { User, EducationHistory, WorkHistory, Articles, Books, Projects, AcademicTitles, ForeignLanguages, Awards, Mentorings, TeachingMajors } = data || {};

    const {
        startYear = '',
        endYear = '',
        articleType = 'ALL',
        selectedSections = Array.from({ length: 16 }, (_, i) => i + 1)
    } = filters || {};

    const fullName = `${User?.LastName || ''} ${User?.FirstName || ''}`.trim() || '........................';
    const currentAcademic = AcademicTitles && AcademicTitles.length > 0
        ? (AcademicTitles.find(t => t.IsCurrent) || AcademicTitles[0])
        : null;

    const formatYear = (dateStr) => {
        if (!dateStr || dateStr.includes('1970') || dateStr.startsWith('0001')) return '';
        let d;
        if (typeof dateStr === 'string' && dateStr.includes('/Date(')) {
            const ticks = parseInt(dateStr.replace(/\/Date\((.*?)\)\//, '$1'), 10);
            d = new Date(ticks);
        } else {
            d = new Date(dateStr);
        }
        if (isNaN(d.getFullYear()) || d.getFullYear() === 1970 || d.getFullYear() === 1) return '';
        return d.getFullYear();
    };

    const formatMonthYear = (dateStr) => {
        if (!dateStr || dateStr.includes('1970') || dateStr.startsWith('0001')) return '';
        let d;
        if (typeof dateStr === 'string' && dateStr.includes('/Date(')) {
            const ticks = parseInt(dateStr.replace(/\/Date\((.*?)\)\//, '$1'), 10);
            d = new Date(ticks);
        } else {
            d = new Date(dateStr);
        }
        if (isNaN(d.getTime()) || d.getFullYear() === 1970 || d.getFullYear() === 1) return '';
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        return `${month}/${d.getFullYear()}`;
    };

    const getDisplayTime = (work) => {
        const sMonth = formatMonthYear(work.StartDate);
        const sYear = formatYear(work.StartDate);

        if (sMonth || sYear) {
            const start = sMonth || sYear;
            const endMonth = formatMonthYear(work.EndDate);
            const endYear = formatYear(work.EndDate);
            const end = endMonth || endYear || 'Nay';
            return `${start} - ${end}`;
        }

        const raw = work.Position || work.Workplace || '';
        if (!raw) return '';

        let m;

        m = raw.match(/từ\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})\s*đến\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/từ\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})\s*đến\s+(\d{1,2})\s*năm\s*(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/từ\s*năm\s+(\d{4})\s*đến\s*năm\s+(\d{4})/i);
        if (m) return `${m[1]} - ${m[2]}`;

        m = raw.match(/Từ\s+(\d{1,2})\/(\d{4})\s+đến\s+(\d{1,2})\/(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/Từ\s+(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/Từ\s+(\d{4})\s+đến\s+(\d{1,2})\/(\d{4})/i);
        if (m) return `${m[1]} - ${m[2].padStart(2, '0')}/${m[3]}`;

        m = raw.match(/Từ\s+(\d{1,2})\/(\d{4})\s+đến\s+(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3]}`;

        m = raw.match(/Từ\s+(\d{4})\s+đến\s+(\d{4})/i);
        if (m) return `${m[1]} - ${m[2]}`;

        m = raw.match(/-\s*(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/^(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - ${m[3].padStart(2, '0')}/${m[4]}`;

        m = raw.match(/-\s*(\d{4})\s*-\s*(\d{4})/i);
        if (m) return `${m[1]} - ${m[2]}`;

        m = raw.match(/(\d{4})\s*-\s*(\d{4})/i);
        if (m) return `${m[1]} - ${m[2]}`;

        m = raw.match(/từ\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})\s*đến\s*nay/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - Nay`;

        m = raw.match(/từ\s*năm\s+(\d{4})\s*đến\s*nay/i);
        if (m) return `${m[1]} - Nay`;

        m = raw.match(/Từ\s+(\d{1,2})\/(\d{4})\s+đến\s+nay/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - Nay`;

        m = raw.match(/Từ\s+(\d{4})\s+đến\s+nay/i);
        if (m) return `${m[1]} - Nay`;

        m = raw.match(/-\s*(\d{1,2})\/(\d{4})\s*-\s*nay/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - Nay`;

        m = raw.match(/từ\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})/i);
        if (m) return `${m[1].padStart(2, '0')}/${m[2]} - Nay`;

        m = raw.match(/từ\s*năm\s+(\d{4})/i);
        if (m) return `${m[1]} - Nay`;

        return '';
    };

    const extractDateForSorting = (rawStr) => {
        if (!rawStr) return null;
        let m;

        m = rawStr.match(/Từ\s+(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{4})/i);
        if (m) return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1).getTime();

        m = rawStr.match(/từ\s*tháng\s+(\d{1,2})\s*năm\s*(\d{4})/i);
        if (m) return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1).getTime();

        m = rawStr.match(/từ\s*năm\s+(\d{4})/i);
        if (m) return new Date(parseInt(m[1]), 0, 1).getTime();

        m = rawStr.match(/Từ\s+(\d{1,2})\/(\d{4})/i);
        if (m) return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1).getTime();

        m = rawStr.match(/Từ\s+(\d{4})/i);
        if (m) return new Date(parseInt(m[1]), 0, 1).getTime();

        m = rawStr.match(/-\s*(\d{1,2})\/(\d{4})\s*-/i);
        if (m) return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1).getTime();

        m = rawStr.match(/-\s*(\d{4})\s*-/i);
        if (m) return new Date(parseInt(m[1]), 0, 1).getTime();

        m = rawStr.match(/^(\d{1,2})\/(\d{4})\s*-/i);
        if (m) return new Date(parseInt(m[2]), parseInt(m[1]) - 1, 1).getTime();

        m = rawStr.match(/(\d{4})\s*-/i);
        if (m) return new Date(parseInt(m[1]), 0, 1).getTime();

        return null;
    };

    const sortedWorkHistory = WorkHistory ? [...WorkHistory].sort((a, b) => {
        const getValidTime = (work) => {
            let dateStr = work.StartDate;
            if (dateStr && !dateStr.includes('1970') && !dateStr.startsWith('0001')) {
                let d;
                if (typeof dateStr === 'string' && dateStr.includes('/Date(')) {
                    const ticks = parseInt(dateStr.replace(/\/Date\((.*?)\)\//, '$1'), 10);
                    d = new Date(ticks);
                } else {
                    d = new Date(dateStr);
                }

                if (!isNaN(d.getTime()) && d.getFullYear() !== 1970 && d.getFullYear() !== 1) {
                    return d.getTime();
                }
            }

            return extractDateForSorting(work.Position || work.Workplace);
        };

        const displayA = getDisplayTime(a) || '';
        const displayB = getDisplayTime(b) || '';

        const isOngoingA = displayA.endsWith('Nay');
        const isOngoingB = displayB.endsWith('Nay');

        if (isOngoingA && !isOngoingB) return -1;
        if (!isOngoingA && isOngoingB) return 1;

        const timeA = getValidTime(a);
        const timeB = getValidTime(b);

        if (!timeA && !timeB) return 0;
        if (!timeA) return 1;
        if (!timeB) return -1;

        return timeB - timeA;
    }) : [];

    const removeAccents = (str) => {
        return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase() : '';
    };

    const getQRank = (item) => {
        const q = (item.QRanking || '').trim().toUpperCase();
        const catQ = (item.JournalCategory || '').trim().toUpperCase();
        if (['Q1', 'Q2', 'Q3', 'Q4'].includes(q)) return q;
        if (['Q1', 'Q2', 'Q3', 'Q4'].includes(catQ)) return catQ;
        return '';
    };

    const checkIsInternational = (item) => {
        const typeStr = removeAccents(item.JournalType || '');
        const nameStr = removeAccents(item.JournalName || '');
        const catStr = removeAccents(item.JournalCategory || '');
        const titleStr = item.Title || '';

        const qRank = (item.QRanking || '').trim().toUpperCase();
        const catRaw = (item.JournalCategory || '').trim().toUpperCase();

        const hasVietnameseTitle = /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/i.test(titleStr);

        const strictDomesticJournals = [
            'kinh te va phat trien', 'khoa hoc kinh te', 'kh & cn', 'khoa hoc va cong nghe',
            'dai hoc', 'ky yeu', 'quoc gia', 'dhdn', 'thuong mai', 'quan ly', 'phat trien kinh te',
            'journal of science and technology', 'science and technology development',
            'ho chi minh', 'vnu', 'kinh te va quan ly', 'tap chi vn'
        ];

        if (strictDomesticJournals.some(kw => nameStr.includes(kw))) {
            return false;
        }

        const isQ = ['Q1', 'Q2', 'Q3', 'Q4'];
        if (isQ.includes(qRank) || isQ.includes(catRaw)) return true;

        const strongIntlKeywords = ['scopus', 'scie', 'ssci', 'isi', 'esci', 'springer', 'emerald', 'elsevier', 'mdpi'];
        if (strongIntlKeywords.some(kw => nameStr.includes(kw) || typeStr.includes(kw))) {
            return true;
        }

        if (!hasVietnameseTitle) {
            return true;
        } else {
            return false;
        }
    };

    const formatPaperTitle = (title) => {
        if (!title) return '';

        const upperCount = (title.match(/[A-ZÁÀẢÃẠÂẤẦẨẪẬĂẮẰẲẴẶÉÈẺẼẸÊẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌÔỐỒỔỖỘƠỚỜỞỠỢÚÙỦŨỤƯỨỪỬỮỰÝỲỶỸỴĐ]/g) || []).length;
        const isAllCaps = upperCount === title.replace(/[^A-Za-zÁÀẢÃẠÂẤẦẨẪẬĂẮẰẲẴẶÉÈẺẼẸÊẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌÔỐỒỔỖỘƠỚỜỞỠỢÚÙỦŨỤƯỨỪỬỮỰÝỲỶỸỴĐ]/g, '').length;

        let formattedStr = title;

        if (isAllCaps || upperCount < title.split(' ').length) {
            const minorWords = ['a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'from', 'by', 'in', 'of', 'với', 'và', 'của', 'trong', 'tại', 'từ', 'về'];

            formattedStr = title.toLowerCase().replace(/(?:^|\s|-|\/|\(|\[)\S/g, (match, offset, string) => {
                const wordMatch = string.substring(offset).match(/^[^\s-/\)\]]+/);
                const word = wordMatch ? wordMatch[0].toLowerCase() : '';

                if (offset > 0 && minorWords.includes(word)) {
                    const isAfterColon = offset >= 2 && string.substring(offset - 2, offset).includes(':');
                    if (!isAfterColon) {
                        return match.toLowerCase();
                    }
                }
                return match.toUpperCase();
            });
        }

        return formattedStr;
    };

    const formatJournalName = (name) => {
        if (!name) return '';

        const letters = name.match(/[a-zA-ZÁÀẢÃẠÂẤẦẨẪẬĂẮẰẲẴẶÉÈẺẼẸÊẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌÔỐỒỔỖỘƠỚỜỞỠỢÚÙỦŨỤƯỨỪỬỮỰÝỲỶỸỴĐ]/g) || [];
        const upperLetters = name.match(/[A-ZÁÀẢÃẠÂẤẦẨẪẬĂẮẰẲẴẶÉÈẺẼẸÊẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌÔỐỒỔỖỘƠỚỜỞỠỢÚÙỦŨỤƯỨỪỬỮỰÝỲỶỸỴĐ]/g) || [];

        if (letters.length > 0 && (upperLetters.length / letters.length) > 0.6) {
            const minorWords = ['a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'from', 'by', 'in', 'of', 'với', 'và', 'của', 'trong', 'tại', 'từ', 'về'];

            return name.toLowerCase().replace(/(?:^|\s|-|\/|\(|\[)\S/g, (match, offset, string) => {
                const wordMatch = string.substring(offset).match(/^[^\s-/\)\]]+/);
                const word = wordMatch ? wordMatch[0].toLowerCase() : '';

                if (offset > 0 && minorWords.includes(word)) {
                    const isAfterColon = offset >= 2 && string.substring(offset - 2, offset).includes(':');
                    if (!isAfterColon) {
                        return match.toLowerCase();
                    }
                }
                return match.toUpperCase();
            });
        }

        return name;
    };

    const internationalArticles = [];
    const domesticArticles = [];
    const qStats = { Q1: 0, Q2: 0, Q3: 0, Q4: 0, Khac: 0 };

    if (Articles && Articles.length > 0) {
        const sortedArticles = [...Articles].sort((a, b) => {
            const yearA = parseInt(formatYear(a.PublicationDate)) || 0;
            const yearB = parseInt(formatYear(b.PublicationDate)) || 0;
            return yearB - yearA;
        });

        sortedArticles.forEach(art => {
            const pubYear = parseInt(formatYear(art.PublicationDate)) || 0;

            if (startYear && pubYear > 0 && pubYear < parseInt(startYear)) return;
            if (endYear && pubYear > 0 && pubYear > parseInt(endYear)) return;

            const isIntl = checkIsInternational(art);
            const qRank = getQRank(art);
            art.finalQRank = qRank;

            if (articleType === 'INTERNATIONAL' && !isIntl) return;
            if (articleType === 'DOMESTIC' && isIntl) return;

            if (isIntl) {
                internationalArticles.push(art);
                if (qRank) {
                    qStats[qRank]++;
                } else {
                    qStats.Khac++;
                }
            } else {
                domesticArticles.push(art);
            }
        });
    }

    const sortedAwards = Awards ? [...Awards].sort((a, b) => {
        const yearA = parseInt(formatYear(a.SignatureDate || a.AwardYear || a.Date)) || 0;
        const yearB = parseInt(formatYear(b.SignatureDate || b.AwardYear || b.Date)) || 0;
        return yearB - yearA;
    }) : [];

    const sortedMentorings = Mentorings ? [...Mentorings].sort((a, b) => {
        const yearA = parseInt(formatYear(a.GraduationYear || a.StartYear)) || 0;
        const yearB = parseInt(formatYear(b.GraduationYear || b.StartYear)) || 0;
        return yearB - yearA;
    }) : [];

    let currentSectionNum = 1;
    const isVisible = (id) => selectedSections.includes(id);
    const getNum = () => currentSectionNum++;

    const isStandardFormat = selectedSections.length === 16;
    const showWordSection2 = isVisible(12) || isVisible(13) || isVisible(14) || isVisible(15);

    return (
        <div className="printable-cv">
            <div className="WordSection1">
                <div className="cv-header">
                    <h2>LÝ LỊCH KHOA HỌC</h2>
                    <h3>CHUYÊN GIA KHOA HỌC VÀ CÔNG NGHỆ</h3>
                    {isStandardFormat && (
                        <p className="italic">(Kèm theo Quyết định số 588/QĐ-BKHCN ngày 31 tháng 3 năm 2014 của Bộ trưởng Bộ Khoa học và Công nghệ)</p>
                    )}
                </div>

                <div className="cv-section">
                    {isVisible(1) && <p><strong>{getNum()}. Họ và tên:</strong> {fullName}</p>}

                    <table className="no-border-table" style={{ width: '100%', border: 'none', marginTop: '8px', tableLayout: 'fixed' }}>
                        <tbody>
                            {(isVisible(2) || isVisible(3)) && (
                                <tr>
                                    {isVisible(2) && (
                                        <td style={{ width: isVisible(3) ? '60%' : '100%', border: 'none', padding: '4px 0' }} colSpan={isVisible(3) ? 1 : 2}>
                                            <strong>{getNum()}. Năm sinh:</strong> {formatYear(User?.DateOfBirth) || '........'}
                                        </td>
                                    )}
                                    {isVisible(3) && (
                                        <td style={{ width: isVisible(2) ? '40%' : '100%', border: 'none', padding: '4px 0' }} colSpan={isVisible(2) ? 1 : 2}>
                                            <strong>{getNum()}. Nam/Nữ:</strong> {User?.Gender || '........'}
                                        </td>
                                    )}
                                </tr>
                            )}
                            {isVisible(4) && (
                                <>
                                    <tr>
                                        <td style={{ border: 'none', padding: '4px 0' }}>
                                            <strong>{getNum()}. Học hàm:</strong> {currentAcademic?.AcademicRank || currentAcademic?.TitleName || User?.JobTitleName || '................'}
                                        </td>
                                        <td style={{ border: 'none', padding: '4px 0' }}>
                                            <strong>Năm được phong:</strong> {formatYear(currentAcademic?.TitleDate) || '........'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: 'none', padding: '4px 0' }}>
                                            <strong>Học vị:</strong> {currentAcademic?.DegreeName || User?.DegreeName || '................'}
                                        </td>
                                        <td style={{ border: 'none', padding: '4px 0' }}>
                                            <strong>Năm đạt học vị:</strong> {formatYear(currentAcademic?.DegreeDate) || '........'}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>

                    {isVisible(5) && (
                        <div className="keep-together" style={{ marginTop: '15px', marginBottom: '15px' }}>
                            <p className="section-title"><strong>{getNum()}. Lĩnh vực nghiên cứu trong 5 năm gần đây:</strong></p>
                            <table className="research-field-table" style={{ width: '100%', border: 'none', marginLeft: '20px', lineHeight: '2' }}>
                                <tbody>
                                    <tr>
                                        <td width="50%"><input type="checkbox" readOnly /> Khoa học Tự nhiên</td>
                                        <td width="50%"><input type="checkbox" readOnly /> Khoa học Kỹ thuật và Công nghệ</td>
                                    </tr>
                                    <tr>
                                        <td><input type="checkbox" readOnly /> Khoa học Y dược</td>
                                        <td><input type="checkbox" readOnly checked={User?.ResearchField?.includes('Xã hội')} /> Khoa học Xã hội</td>
                                    </tr>
                                    <tr>
                                        <td><input type="checkbox" readOnly checked={User?.ResearchField?.includes('Nhân văn')} /> Khoa học Nhân văn</td>
                                        <td><input type="checkbox" readOnly checked={User?.ResearchField?.includes('Nông nghiệp')} /> Khoa học Nông nghiệp</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="no-border-table" style={{ width: '100%', border: 'none', marginLeft: '20px', marginTop: '10px' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '50%', border: 'none', padding: 0 }}><strong>Mã chuyên ngành KH&CN:</strong> .........................</td>
                                        <td style={{ width: '50%', border: 'none', padding: 0 }}><strong>Tên gọi:</strong> {User?.ResearchField || '........................................'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

                    {isVisible(6) && (
                        <>
                            <p><strong>{getNum()}. Chức danh nghiên cứu:</strong> ................................................................................................</p>
                            <p><strong>Chức vụ hiện nay:</strong> {User?.AdminPosition || '................................................'}</p>
                        </>
                    )}

                    {isVisible(7) && (
                        <>
                            <p><strong>{getNum()}. Địa chỉ nhà riêng:</strong> {User?.Address || '..................................................................'}</p>
                            <p>Điện thoại CQ: {User?.Phone || '..................'}; Mobile: {User?.Phone || '..................'}; E-mail: {User?.Email}</p>
                        </>
                    )}

                    {isVisible(8) && (
                        <div className="keep-together">
                            <p className="section-title"><strong>{getNum()}. Cơ quan công tác:</strong></p>
                            <table className="layout-table" style={{ border: 'none', width: '100%', marginLeft: '20px' }}>
                                <tbody>
                                    <tr>
                                        <td width="180" style={{ padding: '4px 0' }}>Tên cơ quan:</td>
                                        <td style={{ padding: '4px 0' }}>
                                            {User?.DepartmentName
                                                ? (User.DepartmentName.includes('Đại học Đà Nẵng')
                                                    ? User.DepartmentName
                                                    : `${User.DepartmentName} - Đại học Đà Nẵng`)
                                                : 'Trường Đại học Kinh tế - Đại học Đà Nẵng'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '4px 0' }}>Địa chỉ cơ quan:</td>
                                        <td style={{ padding: '4px 0' }}>71 Ngũ Hành Sơn, Q.Ngũ Hành Sơn, Tp. Đà Nẵng</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {isVisible(9) && (
                    <div className="cv-section keep-together">
                        <p className="section-title"><strong>{getNum()}. Quá trình đào tạo:</strong></p>
                        <table className="cv-data-table">
                            <thead>
                                <tr>
                                    <th width="20%">Bậc đào tạo</th>
                                    <th width="35%">Nơi đào tạo</th>
                                    <th width="30%">Chuyên ngành</th>
                                    <th width="15%">Năm tốt nghiệp</th>
                                </tr>
                            </thead>
                            <tbody>
                                {EducationHistory && EducationHistory.length > 0 ? (
                                    EducationHistory.map((edu, idx) => (
                                        <tr key={idx}>
                                            <td style={{ textAlign: 'center' }}>{edu.Degree || edu.EducationLevel}</td>
                                            <td>{edu.Institution || edu.School}</td>
                                            <td>{edu.Major}</td>
                                            <td style={{ textAlign: 'center' }}>{formatYear(edu.GraduationYear || edu.EndDate)}</td>
                                        </tr>
                                    ))
                                ) : (<tr><td colSpan="4" style={{ textAlign: 'center' }}>................................</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                )}

                {isVisible(10) && (
                    <div className="cv-section keep-together">
                        <p className="section-title"><strong>{getNum()}. Trình độ ngoại ngữ</strong> <span style={{ fontStyle: 'italic' }}>(ghi rõ mức độ: Tốt/Khá/TB)</span>:</p>
                        <table className="cv-data-table">
                            <thead>
                                <tr>
                                    <th width="10%">TT</th>
                                    <th width="45%">Tên ngoại ngữ</th>
                                    <th width="45%">Điểm/Xếp loại</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ForeignLanguages && ForeignLanguages.length > 0 ? (
                                    ForeignLanguages.map((lang, idx) => (
                                        <tr key={idx}>
                                            <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                            <td style={{ textAlign: 'center' }}>{lang.LanguageName || lang.Language}</td>
                                            <td style={{ textAlign: 'center' }}>{lang.Level || lang.Rating || lang.Score || 'Tốt'}</td>
                                        </tr>
                                    ))
                                ) : (<tr><td colSpan="3" style={{ textAlign: 'center' }}>................................</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                )}

                {isVisible(11) && (
                    <div className="cv-section keep-together">
                        <p className="section-title"><strong>{getNum()}. Quá trình công tác:</strong></p>
                        <table className="cv-data-table">
                            <thead>
                                <tr>
                                    <th width="35%">Thời gian</th>
                                    <th width="30%">Vị trí công tác</th>
                                    <th width="35%">Cơ quan công tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedWorkHistory && sortedWorkHistory.length > 0 ? (
                                    sortedWorkHistory.map((work, idx) => (
                                        <tr key={idx}>
                                            <td style={{ textAlign: 'center' }}>
                                                {getDisplayTime(work)}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{work.Position}</td>
                                            <td style={{ textAlign: 'center' }}>{work.Organization || work.Workplace}</td>
                                        </tr>
                                    ))
                                ) : (<tr><td colSpan="3" style={{ textAlign: 'center' }}>................................</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {showWordSection2 && (
                <>
                    <div className="word-section-break-placeholder no-print"></div>
                    <div className="WordSection2">
                        {isVisible(12) && (
                            <div className="cv-section">
                                <p className="section-title"><strong>{getNum()}. Các công trình KH&CN chủ yếu được công bố, sách giáo trình</strong> <span className="italic">(liệt kê công trình tiêu biểu đã công bố trong 5 năm gần nhất):</span></p>
                                <table className="cv-data-table">
                                    <tbody>
                                        <tr>
                                            <th width="5%" className="col-tt">TT</th>
                                            <th width="23%" className="col-name">Tên công trình (bài báo...)</th>
                                            <th width="16%" className="col-author">Tác giả / Đồng tác giả</th>
                                            <th width="16%" className="col-journal">Nơi công bố (Tạp chí / NXB)</th>
                                            <th width="12%" className="col-vol">Số (Vol/Issue)</th>
                                            <th width="10%" className="col-page">Trang</th>
                                            <th width="10%" className="col-type">Nơi đăng</th>
                                            <th width="8%" className="col-year">Năm</th>
                                        </tr>
                                        <tr className="group-header-row">
                                            <td colSpan="8" className="group-title">
                                                I. Bài báo / Tham luận Quốc tế
                                                {internationalArticles.length > 0 && (
                                                    <span style={{ fontWeight: 'normal', fontSize: '13px', fontStyle: 'italic', marginLeft: '10px' }}>
                                                        (Tổng: {internationalArticles.length} bài. Trong đó Q1: {qStats.Q1}, Q2: {qStats.Q2}, Q3: {qStats.Q3}, Q4: {qStats.Q4}, Khác: {qStats.Khac})
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        {internationalArticles.length > 0 ? internationalArticles.map((art, idx) => (
                                            <tr key={`intl-art-${idx}`}>
                                                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                <td>{formatPaperTitle(art.Title)}</td>
                                                <td style={{ textAlign: 'center' }}>{art.OriginalAuthors || 'Tác giả'}</td>
                                                <td style={{ textAlign: 'center' }}>{formatJournalName(art.JournalName)}</td>
                                                <td style={{ textAlign: 'center' }}>{art.IssueNumber || '---'}</td>
                                                <td style={{ textAlign: 'center' }}>{art.PageRange || '---'}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    Quốc tế {art.finalQRank ? ` (${art.finalQRank})` : ''}
                                                </td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(art.PublicationDate)}</td>
                                            </tr>
                                        )) : (<tr><td colSpan="8" style={{ textAlign: 'center' }}>Chưa có công bố quốc tế nào được duyệt (trong khoảng thời gian/bộ lọc được chọn)</td></tr>)}

                                        <tr className="group-header-row">
                                            <td colSpan="8" className="group-title">
                                                II. Bài báo / Tham luận Trong nước
                                                {domesticArticles.length > 0 && (
                                                    <span style={{ fontWeight: 'normal', fontSize: '13px', fontStyle: 'italic', marginLeft: '10px' }}>
                                                        (Tổng: {domesticArticles.length} bài)
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        {domesticArticles.length > 0 ? domesticArticles.map((art, idx) => (
                                            <tr key={`dom-art-${idx}`}>
                                                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                <td>{formatPaperTitle(art.Title)}</td>
                                                <td style={{ textAlign: 'center' }}>{art.OriginalAuthors || 'Tác giả'}</td>
                                                <td style={{ textAlign: 'center' }}>{formatJournalName(art.JournalName)}</td>
                                                <td style={{ textAlign: 'center' }}>{art.IssueNumber || '---'}</td>
                                                <td style={{ textAlign: 'center' }}>{art.PageRange || '---'}</td>
                                                <td style={{ textAlign: 'center' }}>Trong nước</td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(art.PublicationDate)}</td>
                                            </tr>
                                        )) : (<tr><td colSpan="8" style={{ textAlign: 'center' }}>Chưa có công bố trong nước nào được duyệt (trong khoảng thời gian/bộ lọc được chọn)</td></tr>)}

                                        <tr className="group-header-row"><td colSpan="8" className="group-title">III. Sách / Giáo trình</td></tr>
                                        {Books && Books.length > 0 ? Books.map((book, idx) => (
                                            <tr key={`book-${idx}`}>
                                                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                <td>{book.BookName || book.Title}</td>
                                                <td style={{ textAlign: 'center' }}>{book.OriginalAuthors || 'Tác giả'}</td>
                                                <td style={{ textAlign: 'center' }}>{book.Publisher}</td>
                                                <td style={{ textAlign: 'center' }}>---</td>
                                                <td style={{ textAlign: 'center' }}>---</td>
                                                <td style={{ textAlign: 'center' }}>---</td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(book.PublicationDate || book.PublishDate)}</td>
                                            </tr>
                                        )) : (<tr><td colSpan="8" style={{ textAlign: 'center' }}>Chưa có sách/giáo trình nào được duyệt</td></tr>)}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {isVisible(13) && (
                            <div className="cv-section keep-together">
                                <p className="section-title"><strong>{getNum()}. Các đề tài, dự án, nhiệm vụ KH&CN đã chủ trì hoặc tham gia trong 5 năm gần đây:</strong></p>
                                <table className="cv-data-table">
                                    <tbody>
                                        <tr>
                                            <th width="35%" className="col-proj-name">Tên đề tài, dự án, nhiệm vụ KH&CN đã chủ trì</th>
                                            <th width="25%" className="col-proj-time">Thời gian (bắt đầu - kết thúc)</th>
                                            <th width="20%" className="col-proj-prog">Thuộc Chương trình (nếu có)</th>
                                            <th width="20%" className="col-proj-status">Tình trạng</th>
                                        </tr>
                                        {Projects && Projects.map((proj, idx) => (
                                            <tr key={idx}>
                                                <td>{proj.Title}</td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(proj.StartDate)} - {formatYear(proj.EndDate)}</td>
                                                <td style={{ textAlign: 'center' }}>{proj.ProjectLevel}</td>
                                                <td style={{ textAlign: 'center' }}>Đã nghiệm thu</td>
                                            </tr>
                                        ))}
                                        {(!Projects || Projects.length === 0) && <tr><td colSpan="4" style={{ textAlign: 'center' }}>................................</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {isVisible(14) && (
                            <div className="cv-section keep-together">
                                <p className="section-title"><strong>{getNum()}. Giải thưởng</strong> <span className="italic">(KH&CN, chất lượng sản phẩm, ...):</span></p>
                                <table className="cv-data-table">
                                    <tbody>
                                        <tr>
                                            <th width="10%" className="col-aw-tt">TT</th>
                                            <th width="65%" className="col-aw-content">Hình thức và nội dung giải thưởng</th>
                                            <th width="25%" className="col-aw-year">Năm tặng thưởng</th>
                                        </tr>
                                        {sortedAwards && sortedAwards.length > 0 ? sortedAwards.map((award, idx) => {
                                            const hinhThuc = award.AwardTypeName || award.AwardName || award.Form || '';
                                            const noiDung = award.AwardContent || award.Content || award.Title || '';
                                            const hienThiGiaiThuong = [hinhThuc, noiDung].filter(Boolean).join(' - ') || '................';
                                            const nam = formatYear(award.SignatureDate || award.AwardYear || award.Date) || '........';
                                            return (
                                                <tr key={idx}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td>{hienThiGiaiThuong}</td>
                                                    <td style={{ textAlign: 'center' }}>{nam}</td>
                                                </tr>
                                            );
                                        }) : (<tr><td colSpan="3" style={{ textAlign: 'center' }}>................................</td></tr>)}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {isVisible(15) && (
                            <div className="cv-section keep-together">
                                <p className="section-title"><strong>{getNum()}. Hướng dẫn Sau đại học</strong> <span className="italic">(nếu có):</span></p>
                                <table className="cv-data-table">
                                    <tbody>
                                        <tr>
                                            <th width="8%" className="col-ment-tt">TT</th>
                                            <th width="35%" className="col-ment-name">Họ và tên, Đề tài</th>
                                            <th width="15%" className="col-ment-level">Trình độ</th>
                                            <th width="15%" className="col-ment-school">Cơ sở đào tạo</th>
                                            <th width="15%" className="col-ment-start">Năm hướng dẫn</th>
                                            <th width="15%" className="col-ment-end">Năm bảo vệ</th>
                                        </tr>
                                        {sortedMentorings && sortedMentorings.length > 0 ? sortedMentorings.map((ment, idx) => (
                                            <tr key={idx}>
                                                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                <td>{ment.StudentName} - {ment.TopicName}</td>
                                                <td style={{ textAlign: 'center' }}>{ment.EducationLevel || '..........'}</td>
                                                <td style={{ textAlign: 'center' }}>{ment.SchoolName || ment.Institution || '..........'}</td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(ment.StartYear) || '..........'}</td>
                                                <td style={{ textAlign: 'center' }}>{formatYear(ment.GraduationYear) || '..........'}</td>
                                            </tr>
                                        )) : (<tr><td colSpan="6" style={{ textAlign: 'center' }}>................................</td></tr>)}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </>
            )}

            <div className="word-section-break-placeholder no-print"></div>

            <div className="WordSection3">
                {isVisible(16) && (
                    <div className="cv-section">
                        <p className="section-title"><strong>{getNum()}. Lĩnh vực chuyên môn sâu có thể tư vấn:</strong></p>
                        <ul style={{ paddingLeft: '40px', marginBottom: '25px', lineHeight: '1.8' }}>
                            {TeachingMajors && TeachingMajors.length > 0 ? TeachingMajors.map((major, idx) => (
                                <li key={idx}>{major.TeachingMajorName || major.Name}</li>
                            )) : User?.TeachingMajor ? (
                                <li>{User.TeachingMajor}</li>
                            ) : (
                                <li>....................................................................................................</li>
                            )}
                        </ul>
                        <p style={{ marginTop: '20px' }}>Tôi xin cam đoan những thông tin được ghi ở trên là hoàn toàn chính xác.</p>
                    </div>
                )}

                <table style={{ width: '100%', border: 'none', marginTop: '40px', tableLayout: 'fixed' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '50%', verticalAlign: 'top', border: 'none', textAlign: 'center', padding: '0 15px' }}>
                                <p className="bold" style={{ margin: '0 0 5px 0' }}>Xác nhận của Cơ quan chủ quản</p>
                                <p className="bold" style={{ margin: '0 0 5px 0' }}>Thủ trưởng đơn vị</p>
                                <p className="italic" style={{ margin: '0' }}>(Ký và ghi rõ họ tên)</p>
                            </td>
                            <td style={{ width: '50%', verticalAlign: 'top', border: 'none', textAlign: 'center', padding: '0 15px' }}>
                                <p className="italic" style={{ margin: '0 0 5px 0' }}>Đà Nẵng, ngày ........ tháng ....... năm 20........</p>
                                <p className="bold" style={{ margin: '0 0 5px 0' }}>Người khai</p>
                                <p className="italic" style={{ margin: '0' }}>(Ký và ghi rõ họ tên)</p>
                                <br /><br /><br /><br />
                                <p className="bold" style={{ margin: '0' }}>{fullName}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ScientificCVTemplate;